// API configuration based on environment
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
